import { useEffect, useState } from 'react';
import CountUp from 'react-countup';
import WidgetLink from '../WidgetLink/WidgetLink';
import WidgetShell from '../WidgetShell/WidgetShell';
import { TOTAL_ALLOWED_WORKERS } from 'constants/workers';

const DONUT_RADIUS = 52;
const DONUT_CIRCUMFERENCE = 2 * Math.PI * DONUT_RADIUS;

function WorkersWidget({ data, loading, error, onRetry }) {
  const [isReady, setIsReady] = useState(false);
  const usedWorkers = Object.values(data || {}).reduce((sum, count) => sum + count, 0);
  const visibleWorkers = Math.min(usedWorkers, TOTAL_ALLOWED_WORKERS);
  const usageRatio = TOTAL_ALLOWED_WORKERS > 0 ? visibleWorkers / TOTAL_ALLOWED_WORKERS : 0;

  useEffect(() => {
    const frameId = window.requestAnimationFrame(() => {
      setIsReady(true);
    });

    return () => window.cancelAnimationFrame(frameId);
  }, []);

  return (
    <WidgetShell
      className="h-full"
      title={<WidgetLink to="/workers">Workers</WidgetLink>}
      loading={loading}
      error={error}
      onRetry={onRetry}
    >
      <div className="flex justify-center py-5">
        <div className="relative flex h-48 w-48 items-center justify-center">
          <svg className="h-40 w-40 -rotate-90" viewBox="0 0 120 120" aria-hidden="true">
            <circle
              cx="60"
              cy="60"
              r={DONUT_RADIUS}
              fill="none"
              stroke="rgb(31 41 55)"
              strokeWidth="10"
            />
            <circle
              cx="60"
              cy="60"
              r={DONUT_RADIUS}
              fill="none"
              stroke="rgb(56 189 248)"
              strokeWidth="10"
              strokeLinecap="round"
              style={{
                strokeDasharray: DONUT_CIRCUMFERENCE,
                strokeDashoffset: isReady
                  ? DONUT_CIRCUMFERENCE * (1 - usageRatio)
                  : DONUT_CIRCUMFERENCE,
                transition: 'stroke-dashoffset 700ms ease-out',
              }}
            />
          </svg>

          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className="text-4xl font-bold text-white tabular-nums leading-none">
              <CountUp end={usedWorkers} duration={1.2} preserveValue />
            </span>
            <span className="mt-1 text-sm font-medium text-gray-400 tabular-nums">
              of {TOTAL_ALLOWED_WORKERS}
            </span>
          </div>
        </div>
      </div>
    </WidgetShell>
  );
}

export default WorkersWidget;
